import { Meta } from "../../types/meta";

const meta: Meta = {
  buildNumber: "v0.19.0-beta",
  platformName: "XDI Hub",
};

export default meta;
